import React from 'react';
import { Create, required, SimpleForm, TextInput } from 'react-admin';
import { Wrapper } from '../../components';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';

const ParentFuelCreate = (props) => {
    return (
        <Permission permission={PERMISSIONS.ADMIN}>
            <Wrapper>
                <Create title='Adicionar combustível' {...props}>
                    <SimpleForm sx={{ maxWidth: 600 }}>
                        <TextInput source="acronym" label="Sigla" maxLength="3" validate={required()} sx={{ minWidth: 300 }} />
                        <TextInput source="name" label="Nome" validate={required()} sx={{ minWidth: 300 }} />
                    </SimpleForm>
                </Create>
            </Wrapper>
        </Permission>
    )
};

export default ParentFuelCreate;
